//@ts-nocheck
/**
 * AUTO_GENERATED Do not change this file directly, use config.ts file instead
 *
 * @version 6
 */

import { AxiosRequestConfig } from "axios";
import {
  UseQueryOptions,
  useQuery,
  useMutation,
  UseMutationOptions,
  QueryClient,
  QueryKey,
} from "@tanstack/react-query";
import { RequestError, SwaggerResponse } from "./config";

import type {
  AcknowledgeAlert,
  ActiveBioscope,
  ActivityLogController_getActivityLogQueryParams,
  ActivityLogResponseDto,
  Alert,
  AlertAcknowledgement,
  AllWeeklyReportResponseDto,
  AssignFishGroupsToCycleRequest,
  AssignFishGroupsToCycleResponseDto,
  AuditLogController_exportQueryParams,
  AuditLogController_listQueryParams,
  AuditLogFacetsDto,
  AuditLogOptionsController_scopesQueryParams,
  AuditLogPageDto,
  AuditScopeOptionDto,
  BehaviorController_getOverviewQueryParams,
  BehaviorController_getRespirationQueryParams,
  BehaviorController_getSwimSpeedQueryParams,
  BehaviorController_getTiltQueryParams,
  BiomassController_GetFeedingConversionRateQueryParams,
  BiomassOverviewResponseDto,
  BioscopeDetail,
  BioscopeImage,
  BioscopeImageController_GetImageListQueryParams,
  BioscopeRestart,
  BioscopeRouterRestart,
  BioscopeStreamSettingsRowDto,
  BwWelfareResponse,
  Cage,
  CageActiveFishGroupResponseDto,
  CageContextResponseDto,
  CageController_ContextQueryParams,
  CageController_OverviewQueryParams,
  CageController_getHealthOverviewQueryParams,
  CageController_getWeightDistributionsQueryParams,
  CageController_getWelfareOverviewQueryParams,
  CageDepthSeriesController_getCageDepthSeriesQueryParams,
  CageFishGroupHistoryItemDto,
  CageHealthOverviewResponseDto,
  CageHistoricalDto,
  CageImage,
  CageImageController_GetImageListQueryParams,
  CageListItemDto,
  CageStatus,
  CageWelfareOverviewResponseDto,
  ClarifyCatalogDto,
  ClarifyCatalogRequestDto,
  ClientController_AllLiceDailyReportQueryParams,
  ClientController_AllLiceDailyReportsQueryParams,
  ClientController_AllLiceWeeklyReportQueryParams,
  ClientController_OverviewQueryParams,
  ClientController_RangeLiceReportQueryParams,
  ClientController_RangeLiceReportsQueryParams,
  ClientFishGroupsOverviewDto,
  ClientInfo,
  ClientIntegrationRowDto,
  ClientLicenseResponse,
  ClientLicenseUser,
  ClientOverviewResponseDto,
  ClientSummaryDto,
  ClientWithLocations,
  ClientWithLocationsInfo,
  CloseFishGroupRequest,
  CompareController_getLocationCompareQueryParams,
  CompleteTaskDto,
  Contract,
  ContractLicenseRecord,
  ContractRecord,
  CreateApiUserInput,
  CreateBioscope,
  CreateCagesDto,
  CreateFishGroupRequest,
  CreateManualActivityDto,
  CreateNewClientInput,
  CreateNewContractInput,
  CreateNewContractLicenseInput,
  CreateNewLicenseForClientInput,
  CreateSmoltReportDto,
  CreateStockingCycleRequest,
  CreatedClientDto,
  DailyClientReportResult,
  DailyLiceCountResponseDto,
  DailyReportResult,
  DaysWithImages,
  DeleteUserResponse,
  DepthSeriesResponseDto,
  DiscardFishGroupRequest,
  EmqxJwtPayloadDto,
  FeedingConversionRateResult,
  FeedingDashboardConfigDto,
  FeedingDashboardController_getOverviewQueryParams,
  FeedingDashboardOverviewDto,
  FetchHistoryRequestDto,
  FetchHistoryResultDto,
  FishGroupDetailDto,
  FishGroupDto,
  FishGroupLineageDto,
  FishGroupLocationHistoryItemDto,
  FishGroupOperationRequest,
  FishGroupTimelineDto,
  FishGroupTransferEventDto,
  FishGroupsController_getEventsQueryParams,
  FishType,
  FullSizeImage,
  GetApiUsersResponse,
  GetCageTypesResponse,
  GetWeightDistributionsResponse,
  HealthController_getHealthDataQueryParams,
  HealthController_getQualityQueryParams,
  HealthOverviewDto,
  HealthQualityResponseDto,
  IgnoreTaskDto,
  ImageFeedbackDto,
  InviteForm,
  Last3DaysResponseDto,
  LiceController_DailyLiceQueryParams,
  LiceController_GetTemperatureQueryParams,
  LiceController_Last200LiceQueryParams,
  LiceController_LiceParityQueryParams,
  LiceController_WeeklyLiceQueryParams,
  LiceType,
  LicenseInfo,
  LicenseResponse,
  LicenseUser,
  LocationBioscopeStatusDto,
  LocationCompareResponseDto,
  LocationController_MarkHistoricalQueryParams,
  LocationDepthSeriesController_getLocationDepthSeriesQueryParams,
  LocationFishGroupsController_timelineQueryParams,
  LocationProviderConfigDto,
  LocationResponseDto,
  LocationStreamStatusDto,
  LocationTypeInfo,
  LocationWeightStatusDto,
  LocationsLicenseOverview,
  LoginForm,
  MarkCagesHistoricalRequest,
  Me,
  MoveBioscopeQueryParams,
  NavigationController_searchByNameQueryParams,
  NavigationResolveResponseDto,
  NewLocation,
  NewReport,
  OccupiedPensDto,
  OverviewResponseDto,
  PenOverviewResponseDto,
  ProviderAccountDto,
  ProviderSchemaDto,
  RangeClientReportResult,
  RangeReportResult,
  RecordFishGroupEventRequest,
  RegisterUserForm,
  RelocateFishGroupRequest,
  ReportDetail,
  ReportList,
  ResetPassword,
  ResetPasswordRequest,
  RespirationResponseDto,
  RevertFishGroupOperationRequest,
  RevertPreviewDto,
  SanityContentResponse,
  SaveProviderAccountRequestDto,
  SaveProviderConfigRequestDto,
  SetUserClientAccessForm,
  SiteDelousingRequest,
  SiteRelocateFishGroupRequest,
  SiteStockingAssignmentRequest,
  SmoltReportController_createReportQueryParams,
  SmoltReportDetailResponseDto,
  SmoltReportListResponseDto,
  SmsInput,
  StockingCycleDto,
  StockingCycleListDto,
  StockingCyclesController_assignFishGroupsQueryParams,
  StockingLineageDto,
  SwimSpeedResponseDto,
  TaskListResponseDto,
  TaskResponseDto,
  TasksController_getTasksQueryParams,
  TemperatureResult,
  TestProviderConfigRequestDto,
  TestProviderConfigResultDto,
  TiltResponseDto,
  UnacknowledgeAlert,
  UnassignFishGroupsFromCycleResponseDto,
  UpdateBioscope,
  UpdateCageActiveFishGroupRequest,
  UpdateCageDto,
  UpdateCageResponse,
  UpdateClientDto,
  UpdateClientLicenseInput,
  UpdateFeedingCageConfigDto,
  UpdateFeedingDashboardConfigDto,
  UpdateFishGroupMetadataRequest,
  UpdateLocation,
  UpdateStockingCycleRequest,
  UpdateUserProfileDto,
  UpdateVideoStreamSettingsInput,
  UserProfileDto,
  VideoStreamSettingsDto,
  WeeklyLiceCountResponseDto,
  WelfareController_allImagesQueryParams,
  WelfareController_getFullWelfareQueryParams,
  Client,
} from "./types";
import {
  AcknowledgedAlertsController_acknowledgeAlert,
  AcknowledgedAlertsController_getAcknowledgements,
  AcknowledgedAlertsController_unacknowledgeAlert,
  ActivityLogController_createManualActivity,
  ActivityLogController_getActivityLog,
  AlertsController_allAlerts,
  AuditLogController_export,
  AuditLogController_list,
  AuditLogOptionsController_facets,
  AuditLogOptionsController_scopes,
  BehaviorController_getOverview,
  BehaviorController_getRespiration,
  BehaviorController_getSwimSpeed,
  BehaviorController_getTilt,
  BiomassController_GetFeedingConversionRate,
  BioscopeController_ActiveBioscopes,
  BioscopeController_ActiveBioscopesForClient,
  BioscopeController_CreateApiKey,
  BioscopeController_CreateBioscope,
  BioscopeController_DeleteBioscope,
  BioscopeController_UpdateBioscope,
  BioscopeDetailController_BioscopeDetailNew,
  BioscopeImageController_GetDaysWithImages,
  BioscopeImageController_GetImageList,
  BioscopeImageController_Image,
  BioscopeRestartController_BioscopeRestarts,
  BioscopeRestartController_BioscopeRouterRestarts,
  BioscopeRestartController_RestartBioscope,
  BioscopeRestartController_RestartRouter,
  CageActiveFishGroupController_getActiveFishGroup,
  CageActiveFishGroupController_updateActiveFishGroup,
  CageController_AllCages,
  CageController_Context,
  CageController_FishTypes,
  CageController_LiceTypes,
  CageController_LocationTypes,
  CageController_Overview,
  CageController_Status,
  CageController_createManyCages,
  CageController_deleteCage,
  CageController_getCageTypes,
  CageController_getCageWinch,
  CageController_getHealthOverview,
  CageController_getWeightDistributions,
  CageController_getWelfareOverview,
  CageController_updateCage,
  CageDepthSeriesController_getCageDepthSeries,
  CageImageController_GetDaysWithImages,
  CageImageController_GetImageList,
  CageImageController_Image,
  ClientController_AllLiceDailyReport,
  ClientController_AllLiceDailyReports,
  ClientController_AllLiceWeeklyReport,
  ClientController_CreateNewClient,
  ClientController_GetAllClientsWithLocations,
  ClientController_GetClientSummaries,
  ClientController_GetClientWithLocations,
  ClientController_GetClients,
  ClientController_Overview,
  ClientController_RangeLiceReport,
  ClientController_RangeLiceReports,
  ClientController_createApiUser,
  ClientController_getApiUsers,
  ClientController_getClientVideoStreamSettings,
  ClientController_updateBioscopeVideoStreamSettings,
  ClientController_updateClient,
  ClientController_updateLocationVideoStreamSettings,
  CompareController_getLocationCompare,
  ContentController_getSanityContent,
  DeviceKeyController_CreateApiKey,
  FeedbackController_ImageFeedback,
  FeedingDashboardController_getConfig,
  FeedingDashboardController_getOverview,
  FeedingDashboardController_updateCageConfig,
  FeedingDashboardController_updateConfig,
  FishGroupsController_close,
  FishGroupsController_create,
  FishGroupsController_discard,
  FishGroupsController_getCageHistory,
  FishGroupsController_getDetail,
  FishGroupsController_getEvents,
  FishGroupsController_getLineage,
  FishGroupsController_getLocations,
  FishGroupsController_getOverview,
  FishGroupsController_getRevertPreview,
  FishGroupsController_operate,
  FishGroupsController_recordEvent,
  FishGroupsController_relocate,
  FishGroupsController_revertOperation,
  FishGroupsController_updateMetadata,
  HealthController_getHealthData,
  HealthController_getQuality,
  LiceController_DailyLice,
  LiceController_GetTemperature,
  LiceController_Last200Lice,
  LiceController_LiceParity,
  LiceController_WeeklyLice,
  LicenseController_addContractLicense,
  LicenseController_archiveContract,
  LicenseController_createContract,
  LicenseController_createNewLicenseForClient,
  LicenseController_deleteClientLicenses,
  LicenseController_deleteContractLicense,
  LicenseController_getAllClientUser,
  LicenseController_getAllClientWithUser,
  LicenseController_getAllUser,
  LicenseController_getClientContracts,
  LicenseController_getClientLicenses,
  LicenseController_getLicense,
  LicenseController_getLocationsLicense,
  LicenseController_unarchiveContract,
  LicenseController_updateClientLicense,
  LicenseController_updateContract,
  LicenseController_updateContractLicense,
  LocationController_CreateLocation,
  LocationController_DeleteLocation,
  LocationController_LocationBioscopeStatus,
  LocationController_LocationWeightStatus,
  LocationController_MarkCagesHistorical,
  LocationController_MarkHistorical,
  LocationController_UpdateLocation,
  LocationDepthSeriesController_getLocationDepthSeries,
  LocationFishGroupsController_create,
  LocationFishGroupsController_occupiedPens,
  LocationFishGroupsController_timeline,
  MoveBioscopeController_DeleteLastMove,
  MoveBioscopeController_MoveBioscope,
  MqttJwtController_generateEmqxToken,
  NavigationController_resolveById,
  NavigationController_searchByName,
  PenOverviewController_getPenOverview,
  ProviderAccountsController_getAccounts,
  ProviderAccountsController_getClientIntegrations,
  ProviderAccountsController_saveAccount,
  ProviderConfigActionsController_fetchHistory,
  ProviderConfigActionsController_listClarifyCatalog,
  ProviderConfigActionsController_testProviderConfig,
  ProviderConfigController_getLocationConfig,
  ProviderConfigController_getProviderSchemas,
  ProviderConfigController_saveProviderConfig,
  ReportsController_CreateReport,
  ReportsController_DeleteReport,
  ReportsController_Report,
  ReportsController_ReportList,
  SiteFishGroupActionsController_operate,
  SiteFishGroupActionsController_recordDelousing,
  SiteFishGroupActionsController_relocate,
  SiteStockingAssignmentController_assign,
  SiteStockingAssignmentController_previewLineage,
  SiteStockingAssignmentController_unassign,
  SmoltReportController_createReport,
  SmoltReportController_deleteReport,
  SmoltReportController_getReportDetail,
  SmoltReportController_listReports,
  SmsController_SmsWebhook,
  StockingCyclesController_assignFishGroups,
  StockingCyclesController_create,
  StockingCyclesController_list,
  StockingCyclesController_update,
  StockingCyclesController_updateAtSite,
  TasksController_completeTask,
  TasksController_getTasks,
  TasksController_ignoreTask,
  TasksController_unignoreTask,
  UserController_DeleteUser,
  UserController_EndImpersonate,
  UserController_ImpersonateUser,
  UserController_InviteUser,
  UserController_Login,
  UserController_Logout,
  UserController_Me,
  UserController_RegisterUser,
  UserController_ResetPassword,
  UserController_ResetPasswordRequest,
  UserController_SetUserClientAccess,
  UserController_UpdateProfile,
  VideoStreamController_disableBioscopeStream,
  VideoStreamController_getBioscopeQuotaCheck,
  VideoStreamController_getLocationStreamsStatus,
  VideoStreamController_startStream,
  VideoStreamController_stopStream,
  VideoStreamWebhookNewController_handleMuxWebhook,
  WelfareController_GetFullSizeImage,
  WelfareController_allImages,
  WelfareController_getFullWelfare,
  WinchController_CreateApiKey,
} from "./services";

export type SwaggerTypescriptMutationDefaultParams<TExtra> = {
  _extraVariables?: TExtra;
  configOverride?: AxiosRequestConfig;
};
type SwaggerTypescriptUseQueryOptions<TData> = Omit<
  UseQueryOptions<SwaggerResponse<TData>, RequestError | Error>,
  "queryKey"
>;

type SwaggerTypescriptUseMutationOptions<TData, TRequest, TExtra> =
  UseMutationOptions<
    SwaggerResponse<TData>,
    RequestError | Error,
    TRequest & SwaggerTypescriptMutationDefaultParams<TExtra>
  >;

type SwaggerTypescriptUseMutationOptionsVoid<TData, TExtra> =
  UseMutationOptions<
    SwaggerResponse<TData>,
    RequestError | Error,
    SwaggerTypescriptMutationDefaultParams<TExtra> | void
  >;

/**
 *
 * Acknowledge an alert
 */
export const useAcknowledgedAlertsController_acknowledgeAlert = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    AlertAcknowledgement,
    { requestBody: AcknowledgeAlert },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return AcknowledgedAlertsController_acknowledgeAlert(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Get all acknowledgements
 */
export const useAcknowledgedAlertsController_getAcknowledgements = (
  options?: SwaggerTypescriptUseQueryOptions<AlertAcknowledgement[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useAcknowledgedAlertsController_getAcknowledgements.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useAcknowledgedAlertsController_getAcknowledgements.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [AcknowledgedAlertsController_getAcknowledgements.key] as QueryKey,
    fun: () => AcknowledgedAlertsController_getAcknowledgements(configOverride),
  };
};
useAcknowledgedAlertsController_getAcknowledgements.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<AlertAcknowledgement[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useAcknowledgedAlertsController_getAcknowledgements.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Unacknowledge an alert
 */
export const useAcknowledgedAlertsController_unacknowledgeAlert = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    AlertAcknowledgement,
    { requestBody: UnacknowledgeAlert },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return AcknowledgedAlertsController_unacknowledgeAlert(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useActivityLogController_createManualActivity = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { locationId: number; requestBody: CreateManualActivityDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        locationId,
        requestBody,

        configOverride,
      } = _o || {};

      return ActivityLogController_createManualActivity(
        locationId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useActivityLogController_getActivityLog = (
  locationId: number,
  queryParams?: ActivityLogController_getActivityLogQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<ActivityLogResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useActivityLogController_getActivityLog.info(
    locationId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useActivityLogController_getActivityLog.info = (
  locationId: number,
  queryParams?: ActivityLogController_getActivityLogQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      ActivityLogController_getActivityLog.key,
      locationId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      ActivityLogController_getActivityLog(
        locationId,

        queryParams,

        configOverride,
      ),
  };
};
useActivityLogController_getActivityLog.prefetch = (
  client: QueryClient,
  locationId: number,
  queryParams?: ActivityLogController_getActivityLogQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<ActivityLogResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useActivityLogController_getActivityLog.info(
    locationId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useAlertsController_allAlerts = (
  options?: SwaggerTypescriptUseQueryOptions<Alert[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useAlertsController_allAlerts.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useAlertsController_allAlerts.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [AlertsController_allAlerts.key] as QueryKey,
    fun: () => AlertsController_allAlerts(configOverride),
  };
};
useAlertsController_allAlerts.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<Alert[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useAlertsController_allAlerts.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Export the matching audit log entries as CSV
 */
export const useAuditLogController_export = (
  queryParams?: AuditLogController_exportQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<string>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useAuditLogController_export.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useAuditLogController_export.info = (
  queryParams?: AuditLogController_exportQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [AuditLogController_export.key, queryParams] as QueryKey,
    fun: () =>
      AuditLogController_export(
        queryParams,

        configOverride,
      ),
  };
};
useAuditLogController_export.prefetch = (
  client: QueryClient,
  queryParams?: AuditLogController_exportQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<string>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useAuditLogController_export.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * List audit log entries, newest first, paged by id
 */
export const useAuditLogController_list = (
  queryParams?: AuditLogController_listQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<AuditLogPageDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useAuditLogController_list.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useAuditLogController_list.info = (
  queryParams?: AuditLogController_listQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [AuditLogController_list.key, queryParams] as QueryKey,
    fun: () =>
      AuditLogController_list(
        queryParams,

        configOverride,
      ),
  };
};
useAuditLogController_list.prefetch = (
  client: QueryClient,
  queryParams?: AuditLogController_listQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<AuditLogPageDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useAuditLogController_list.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * The actions and target types present in the audit log
 */
export const useAuditLogOptionsController_facets = (
  options?: SwaggerTypescriptUseQueryOptions<AuditLogFacetsDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useAuditLogOptionsController_facets.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useAuditLogOptionsController_facets.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [AuditLogOptionsController_facets.key] as QueryKey,
    fun: () => AuditLogOptionsController_facets(configOverride),
  };
};
useAuditLogOptionsController_facets.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<AuditLogFacetsDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useAuditLogOptionsController_facets.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Clients, sites and pens to filter the audit log by, found by name or id
 */
export const useAuditLogOptionsController_scopes = (
  queryParams: AuditLogOptionsController_scopesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<AuditScopeOptionDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useAuditLogOptionsController_scopes.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useAuditLogOptionsController_scopes.info = (
  queryParams: AuditLogOptionsController_scopesQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [AuditLogOptionsController_scopes.key, queryParams] as QueryKey,
    fun: () =>
      AuditLogOptionsController_scopes(
        queryParams,

        configOverride,
      ),
  };
};
useAuditLogOptionsController_scopes.prefetch = (
  client: QueryClient,
  queryParams: AuditLogOptionsController_scopesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<AuditScopeOptionDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useAuditLogOptionsController_scopes.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Get behavior overview for a cage
 */
export const useBehaviorController_getOverview = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getOverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<OverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBehaviorController_getOverview.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBehaviorController_getOverview.info = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getOverviewQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [BehaviorController_getOverview.key, cageId, queryParams] as QueryKey,
    fun: () =>
      BehaviorController_getOverview(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useBehaviorController_getOverview.prefetch = (
  client: QueryClient,

  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getOverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<OverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBehaviorController_getOverview.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Get respiration data for a cage
 */
export const useBehaviorController_getRespiration = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getRespirationQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<RespirationResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBehaviorController_getRespiration.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBehaviorController_getRespiration.info = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getRespirationQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      BehaviorController_getRespiration.key,
      cageId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      BehaviorController_getRespiration(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useBehaviorController_getRespiration.prefetch = (
  client: QueryClient,

  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getRespirationQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<RespirationResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBehaviorController_getRespiration.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Get swim speed data for a cage
 */
export const useBehaviorController_getSwimSpeed = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getSwimSpeedQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<SwimSpeedResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBehaviorController_getSwimSpeed.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBehaviorController_getSwimSpeed.info = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getSwimSpeedQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [BehaviorController_getSwimSpeed.key, cageId, queryParams] as QueryKey,
    fun: () =>
      BehaviorController_getSwimSpeed(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useBehaviorController_getSwimSpeed.prefetch = (
  client: QueryClient,

  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getSwimSpeedQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<SwimSpeedResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBehaviorController_getSwimSpeed.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Get tilt data for a cage
 */
export const useBehaviorController_getTilt = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getTiltQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<TiltResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBehaviorController_getTilt.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBehaviorController_getTilt.info = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getTiltQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [BehaviorController_getTilt.key, cageId, queryParams] as QueryKey,
    fun: () =>
      BehaviorController_getTilt(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useBehaviorController_getTilt.prefetch = (
  client: QueryClient,

  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: BehaviorController_getTiltQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<TiltResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBehaviorController_getTilt.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useBiomassController_GetFeedingConversionRate = (
  cageId: number,
  queryParams: BiomassController_GetFeedingConversionRateQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<FeedingConversionRateResult>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBiomassController_GetFeedingConversionRate.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBiomassController_GetFeedingConversionRate.info = (
  cageId: number,
  queryParams: BiomassController_GetFeedingConversionRateQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      BiomassController_GetFeedingConversionRate.key,
      cageId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      BiomassController_GetFeedingConversionRate(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useBiomassController_GetFeedingConversionRate.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams: BiomassController_GetFeedingConversionRateQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<FeedingConversionRateResult>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBiomassController_GetFeedingConversionRate.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useBioscopeController_ActiveBioscopes = (
  options?: SwaggerTypescriptUseQueryOptions<ActiveBioscope[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useBioscopeController_ActiveBioscopes.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBioscopeController_ActiveBioscopes.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [BioscopeController_ActiveBioscopes.key] as QueryKey,
    fun: () => BioscopeController_ActiveBioscopes(configOverride),
  };
};
useBioscopeController_ActiveBioscopes.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<ActiveBioscope[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useBioscopeController_ActiveBioscopes.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useBioscopeController_ActiveBioscopesForClient = (
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<ActiveBioscope[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeController_ActiveBioscopesForClient.info(
    clientId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBioscopeController_ActiveBioscopesForClient.info = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      BioscopeController_ActiveBioscopesForClient.key,
      clientId,
    ] as QueryKey,
    fun: () =>
      BioscopeController_ActiveBioscopesForClient(
        clientId,

        configOverride,
      ),
  };
};
useBioscopeController_ActiveBioscopesForClient.prefetch = (
  client: QueryClient,
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<ActiveBioscope[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeController_ActiveBioscopesForClient.info(
    clientId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useBioscopeController_CreateApiKey = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { bioscopeId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        bioscopeId,

        configOverride,
      } = _o || {};

      return BioscopeController_CreateApiKey(
        bioscopeId,

        configOverride,
      );
    },
    ...options,
  });
};

export const useBioscopeController_CreateBioscope = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: CreateBioscope },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return BioscopeController_CreateBioscope(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useBioscopeController_DeleteBioscope = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { bioscopeId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        bioscopeId,

        configOverride,
      } = _o || {};

      return BioscopeController_DeleteBioscope(
        bioscopeId,

        configOverride,
      );
    },
    ...options,
  });
};

export const useBioscopeController_UpdateBioscope = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { bioscopeId: number; requestBody: UpdateBioscope },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        bioscopeId,
        requestBody,

        configOverride,
      } = _o || {};

      return BioscopeController_UpdateBioscope(
        bioscopeId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useBioscopeDetailController_BioscopeDetailNew = (
  bioscopeId: number,
  options?: SwaggerTypescriptUseQueryOptions<BioscopeDetail>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeDetailController_BioscopeDetailNew.info(
    bioscopeId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBioscopeDetailController_BioscopeDetailNew.info = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      BioscopeDetailController_BioscopeDetailNew.key,
      bioscopeId,
    ] as QueryKey,
    fun: () =>
      BioscopeDetailController_BioscopeDetailNew(
        bioscopeId,

        configOverride,
      ),
  };
};
useBioscopeDetailController_BioscopeDetailNew.prefetch = (
  client: QueryClient,
  bioscopeId: number,
  options?: SwaggerTypescriptUseQueryOptions<BioscopeDetail>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeDetailController_BioscopeDetailNew.info(
    bioscopeId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Days that have bioscope inspection images for a device
 */
export const useBioscopeImageController_GetDaysWithImages = (
  bioscopeId: number,
  options?: SwaggerTypescriptUseQueryOptions<DaysWithImages[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeImageController_GetDaysWithImages.info(
    bioscopeId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBioscopeImageController_GetDaysWithImages.info = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      BioscopeImageController_GetDaysWithImages.key,
      bioscopeId,
    ] as QueryKey,
    fun: () =>
      BioscopeImageController_GetDaysWithImages(
        bioscopeId,

        configOverride,
      ),
  };
};
useBioscopeImageController_GetDaysWithImages.prefetch = (
  client: QueryClient,
  bioscopeId: number,
  options?: SwaggerTypescriptUseQueryOptions<DaysWithImages[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeImageController_GetDaysWithImages.info(
    bioscopeId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Bioscope inspection images for a single day (defaults to latest)
 */
export const useBioscopeImageController_GetImageList = (
  bioscopeId: number,
  queryParams?: BioscopeImageController_GetImageListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<BioscopeImage[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeImageController_GetImageList.info(
    bioscopeId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBioscopeImageController_GetImageList.info = (
  bioscopeId: number,
  queryParams?: BioscopeImageController_GetImageListQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      BioscopeImageController_GetImageList.key,
      bioscopeId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      BioscopeImageController_GetImageList(
        bioscopeId,

        queryParams,

        configOverride,
      ),
  };
};
useBioscopeImageController_GetImageList.prefetch = (
  client: QueryClient,
  bioscopeId: number,
  queryParams?: BioscopeImageController_GetImageListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<BioscopeImage[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeImageController_GetImageList.info(
    bioscopeId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useBioscopeImageController_Image = (
  bioscopeId: number,
  id: number,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeImageController_Image.info(
    bioscopeId,
    id,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBioscopeImageController_Image.info = (
  bioscopeId: number,
  id: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [BioscopeImageController_Image.key, bioscopeId, id] as QueryKey,
    fun: () =>
      BioscopeImageController_Image(
        bioscopeId,
        id,

        configOverride,
      ),
  };
};
useBioscopeImageController_Image.prefetch = (
  client: QueryClient,
  bioscopeId: number,
  id: number,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeImageController_Image.info(
    bioscopeId,
    id,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useBioscopeRestartController_BioscopeRestarts = (
  bioscopeId: number,
  options?: SwaggerTypescriptUseQueryOptions<BioscopeRestart[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeRestartController_BioscopeRestarts.info(
    bioscopeId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBioscopeRestartController_BioscopeRestarts.info = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      BioscopeRestartController_BioscopeRestarts.key,
      bioscopeId,
    ] as QueryKey,
    fun: () =>
      BioscopeRestartController_BioscopeRestarts(
        bioscopeId,

        configOverride,
      ),
  };
};
useBioscopeRestartController_BioscopeRestarts.prefetch = (
  client: QueryClient,
  bioscopeId: number,
  options?: SwaggerTypescriptUseQueryOptions<BioscopeRestart[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeRestartController_BioscopeRestarts.info(
    bioscopeId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useBioscopeRestartController_BioscopeRouterRestarts = (
  bioscopeId: number,
  options?: SwaggerTypescriptUseQueryOptions<BioscopeRouterRestart[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeRestartController_BioscopeRouterRestarts.info(
    bioscopeId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useBioscopeRestartController_BioscopeRouterRestarts.info = (
  bioscopeId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      BioscopeRestartController_BioscopeRouterRestarts.key,
      bioscopeId,
    ] as QueryKey,
    fun: () =>
      BioscopeRestartController_BioscopeRouterRestarts(
        bioscopeId,

        configOverride,
      ),
  };
};
useBioscopeRestartController_BioscopeRouterRestarts.prefetch = (
  client: QueryClient,
  bioscopeId: number,
  options?: SwaggerTypescriptUseQueryOptions<BioscopeRouterRestart[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useBioscopeRestartController_BioscopeRouterRestarts.info(
    bioscopeId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useBioscopeRestartController_RestartBioscope = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { bioscopeId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        bioscopeId,

        configOverride,
      } = _o || {};

      return BioscopeRestartController_RestartBioscope(
        bioscopeId,

        configOverride,
      );
    },
    ...options,
  });
};

export const useBioscopeRestartController_RestartRouter = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { bioscopeId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        bioscopeId,

        configOverride,
      } = _o || {};

      return BioscopeRestartController_RestartRouter(
        bioscopeId,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * The active fish group in the cage, or null when it is empty
 */
export const useCageActiveFishGroupController_getActiveFishGroup = (
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<CageActiveFishGroupResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageActiveFishGroupController_getActiveFishGroup.info(
    cageId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageActiveFishGroupController_getActiveFishGroup.info = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      CageActiveFishGroupController_getActiveFishGroup.key,
      cageId,
    ] as QueryKey,
    fun: () =>
      CageActiveFishGroupController_getActiveFishGroup(
        cageId,

        configOverride,
      ),
  };
};
useCageActiveFishGroupController_getActiveFishGroup.prefetch = (
  client: QueryClient,
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<CageActiveFishGroupResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageActiveFishGroupController_getActiveFishGroup.info(
    cageId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Correct the name or initial population size of the cage's active fish group. Journalled as a metadata_updated event with the reason, as the fish-group metadata endpoint does.
 */
export const useCageActiveFishGroupController_updateActiveFishGroup = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    CageActiveFishGroupResponseDto,
    { cageId: number; requestBody: UpdateCageActiveFishGroupRequest },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        cageId,
        requestBody,

        configOverride,
      } = _o || {};

      return CageActiveFishGroupController_updateActiveFishGroup(
        cageId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useCageController_AllCages = (
  options?: SwaggerTypescriptUseQueryOptions<CageListItemDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_AllCages.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_AllCages.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [CageController_AllCages.key] as QueryKey,
    fun: () => CageController_AllCages(configOverride),
  };
};
useCageController_AllCages.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<CageListItemDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_AllCages.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Configuration and data-availability context for a single cage
 */
export const useCageController_Context = (
  cageId: number,
  queryParams?: CageController_ContextQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<CageContextResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_Context.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_Context.info = (
  cageId: number,
  queryParams?: CageController_ContextQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [CageController_Context.key, cageId, queryParams] as QueryKey,
    fun: () =>
      CageController_Context(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useCageController_Context.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams?: CageController_ContextQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<CageContextResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_Context.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useCageController_FishTypes = (
  options?: SwaggerTypescriptUseQueryOptions<FishType[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_FishTypes.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_FishTypes.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [CageController_FishTypes.key] as QueryKey,
    fun: () => CageController_FishTypes(configOverride),
  };
};
useCageController_FishTypes.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<FishType[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_FishTypes.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useCageController_LiceTypes = (
  options?: SwaggerTypescriptUseQueryOptions<LiceType[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_LiceTypes.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_LiceTypes.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [CageController_LiceTypes.key] as QueryKey,
    fun: () => CageController_LiceTypes(configOverride),
  };
};
useCageController_LiceTypes.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<LiceType[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_LiceTypes.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useCageController_LocationTypes = (
  options?: SwaggerTypescriptUseQueryOptions<LocationTypeInfo[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_LocationTypes.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_LocationTypes.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [CageController_LocationTypes.key] as QueryKey,
    fun: () => CageController_LocationTypes(configOverride),
  };
};
useCageController_LocationTypes.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<LocationTypeInfo[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_LocationTypes.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Biomass, bioscope, behaviour and environmental overview for a single cage
 */
export const useCageController_Overview = (
  cageId: number,
  queryParams?: CageController_OverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<BiomassOverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_Overview.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_Overview.info = (
  cageId: number,
  queryParams?: CageController_OverviewQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [CageController_Overview.key, cageId, queryParams] as QueryKey,
    fun: () =>
      CageController_Overview(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useCageController_Overview.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams?: CageController_OverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<BiomassOverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_Overview.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useCageController_Status = (
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<CageStatus>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_Status.info(
    cageId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_Status.info = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [CageController_Status.key, cageId] as QueryKey,
    fun: () =>
      CageController_Status(
        cageId,

        configOverride,
      ),
  };
};
useCageController_Status.prefetch = (
  client: QueryClient,
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<CageStatus>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_Status.info(
    cageId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Create multiple cages for a location in one transaction
 */
export const useCageController_createManyCages = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: CreateCagesDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return CageController_createManyCages(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useCageController_deleteCage = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { cageId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        cageId,

        configOverride,
      } = _o || {};

      return CageController_deleteCage(
        cageId,

        configOverride,
      );
    },
    ...options,
  });
};

export const useCageController_getCageTypes = (
  options?: SwaggerTypescriptUseQueryOptions<GetCageTypesResponse>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_getCageTypes.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_getCageTypes.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [CageController_getCageTypes.key] as QueryKey,
    fun: () => CageController_getCageTypes(configOverride),
  };
};
useCageController_getCageTypes.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<GetCageTypesResponse>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_getCageTypes.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useCageController_getCageWinch = (
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<{ [x in string | number]: any }>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_getCageWinch.info(
    cageId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_getCageWinch.info = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [CageController_getCageWinch.key, cageId] as QueryKey,
    fun: () =>
      CageController_getCageWinch(
        cageId,

        configOverride,
      ),
  };
};
useCageController_getCageWinch.prefetch = (
  client: QueryClient,
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<{ [x in string | number]: any }>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_getCageWinch.info(
    cageId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Health summary for a single cage (Cage Dashboard)
 */
export const useCageController_getHealthOverview = (
  cageId: number,
  queryParams?: CageController_getHealthOverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<CageHealthOverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_getHealthOverview.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_getHealthOverview.info = (
  cageId: number,
  queryParams?: CageController_getHealthOverviewQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      CageController_getHealthOverview.key,
      cageId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      CageController_getHealthOverview(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useCageController_getHealthOverview.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams?: CageController_getHealthOverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<CageHealthOverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_getHealthOverview.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useCageController_getWeightDistributions = (
  cageId: number,
  queryParams?: CageController_getWeightDistributionsQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<GetWeightDistributionsResponse>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_getWeightDistributions.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_getWeightDistributions.info = (
  cageId: number,
  queryParams?: CageController_getWeightDistributionsQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      CageController_getWeightDistributions.key,
      cageId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      CageController_getWeightDistributions(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useCageController_getWeightDistributions.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams?: CageController_getWeightDistributionsQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<GetWeightDistributionsResponse>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_getWeightDistributions.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Welfare and swim-speed summary for a single cage
 */
export const useCageController_getWelfareOverview = (
  cageId: number,
  queryParams?: CageController_getWelfareOverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<CageWelfareOverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_getWelfareOverview.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageController_getWelfareOverview.info = (
  cageId: number,
  queryParams?: CageController_getWelfareOverviewQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      CageController_getWelfareOverview.key,
      cageId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      CageController_getWelfareOverview(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useCageController_getWelfareOverview.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams?: CageController_getWelfareOverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<CageWelfareOverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageController_getWelfareOverview.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useCageController_updateCage = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    UpdateCageResponse,
    { cageId: number; requestBody: UpdateCageDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        cageId,
        requestBody,

        configOverride,
      } = _o || {};

      return CageController_updateCage(
        cageId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Average depth for one pen
 */
export const useCageDepthSeriesController_getCageDepthSeries = (
  cageId: number,
  queryParams: CageDepthSeriesController_getCageDepthSeriesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<DepthSeriesResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageDepthSeriesController_getCageDepthSeries.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageDepthSeriesController_getCageDepthSeries.info = (
  cageId: number,
  queryParams: CageDepthSeriesController_getCageDepthSeriesQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      CageDepthSeriesController_getCageDepthSeries.key,
      cageId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      CageDepthSeriesController_getCageDepthSeries(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useCageDepthSeriesController_getCageDepthSeries.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams: CageDepthSeriesController_getCageDepthSeriesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<DepthSeriesResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageDepthSeriesController_getCageDepthSeries.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Days that have bioscope inspection images for a cage
 */
export const useCageImageController_GetDaysWithImages = (
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<DaysWithImages[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageImageController_GetDaysWithImages.info(
    cageId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageImageController_GetDaysWithImages.info = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [CageImageController_GetDaysWithImages.key, cageId] as QueryKey,
    fun: () =>
      CageImageController_GetDaysWithImages(
        cageId,

        configOverride,
      ),
  };
};
useCageImageController_GetDaysWithImages.prefetch = (
  client: QueryClient,
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<DaysWithImages[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageImageController_GetDaysWithImages.info(
    cageId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Bioscope inspection images for a single day (defaults to latest)
 */
export const useCageImageController_GetImageList = (
  cageId: number,
  queryParams?: CageImageController_GetImageListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<CageImage[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageImageController_GetImageList.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageImageController_GetImageList.info = (
  cageId: number,
  queryParams?: CageImageController_GetImageListQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      CageImageController_GetImageList.key,
      cageId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      CageImageController_GetImageList(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useCageImageController_GetImageList.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams?: CageImageController_GetImageListQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<CageImage[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageImageController_GetImageList.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useCageImageController_Image = (
  cageId: number,
  id: number,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageImageController_Image.info(
    cageId,
    id,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCageImageController_Image.info = (
  cageId: number,
  id: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [CageImageController_Image.key, cageId, id] as QueryKey,
    fun: () =>
      CageImageController_Image(
        cageId,
        id,

        configOverride,
      ),
  };
};
useCageImageController_Image.prefetch = (
  client: QueryClient,
  cageId: number,
  id: number,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCageImageController_Image.info(
    cageId,
    id,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useClientController_AllLiceDailyReport = (
  clientId: number,
  queryParams: ClientController_AllLiceDailyReportQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<DailyReportResult>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_AllLiceDailyReport.info(
    clientId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_AllLiceDailyReport.info = (
  clientId: number,
  queryParams: ClientController_AllLiceDailyReportQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      ClientController_AllLiceDailyReport.key,
      clientId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      ClientController_AllLiceDailyReport(
        clientId,

        queryParams,

        configOverride,
      ),
  };
};
useClientController_AllLiceDailyReport.prefetch = (
  client: QueryClient,
  clientId: number,
  queryParams: ClientController_AllLiceDailyReportQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<DailyReportResult>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_AllLiceDailyReport.info(
    clientId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useClientController_AllLiceDailyReports = (
  clientId: number,
  queryParams: ClientController_AllLiceDailyReportsQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<DailyClientReportResult>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_AllLiceDailyReports.info(
    clientId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_AllLiceDailyReports.info = (
  clientId: number,
  queryParams: ClientController_AllLiceDailyReportsQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      ClientController_AllLiceDailyReports.key,
      clientId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      ClientController_AllLiceDailyReports(
        clientId,

        queryParams,

        configOverride,
      ),
  };
};
useClientController_AllLiceDailyReports.prefetch = (
  client: QueryClient,
  clientId: number,
  queryParams: ClientController_AllLiceDailyReportsQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<DailyClientReportResult>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_AllLiceDailyReports.info(
    clientId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Every stored weekly lice report for the client, plus the running week
 */
export const useClientController_AllLiceWeeklyReport = (
  clientId: number,
  queryParams?: ClientController_AllLiceWeeklyReportQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<AllWeeklyReportResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_AllLiceWeeklyReport.info(
    clientId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_AllLiceWeeklyReport.info = (
  clientId: number,
  queryParams?: ClientController_AllLiceWeeklyReportQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      ClientController_AllLiceWeeklyReport.key,
      clientId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      ClientController_AllLiceWeeklyReport(
        clientId,

        queryParams,

        configOverride,
      ),
  };
};
useClientController_AllLiceWeeklyReport.prefetch = (
  client: QueryClient,
  clientId: number,
  queryParams?: ClientController_AllLiceWeeklyReportQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<AllWeeklyReportResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_AllLiceWeeklyReport.info(
    clientId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useClientController_CreateNewClient = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    CreatedClientDto,
    { requestBody: CreateNewClientInput },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return ClientController_CreateNewClient(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useClientController_GetAllClientsWithLocations = (
  options?: SwaggerTypescriptUseQueryOptions<ClientWithLocationsInfo[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useClientController_GetAllClientsWithLocations.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_GetAllClientsWithLocations.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [ClientController_GetAllClientsWithLocations.key] as QueryKey,
    fun: () => ClientController_GetAllClientsWithLocations(configOverride),
  };
};
useClientController_GetAllClientsWithLocations.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<ClientWithLocationsInfo[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useClientController_GetAllClientsWithLocations.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Every client with counts and recency signals, for the internal clients table
 */
export const useClientController_GetClientSummaries = (
  options?: SwaggerTypescriptUseQueryOptions<ClientSummaryDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useClientController_GetClientSummaries.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_GetClientSummaries.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [ClientController_GetClientSummaries.key] as QueryKey,
    fun: () => ClientController_GetClientSummaries(configOverride),
  };
};
useClientController_GetClientSummaries.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<ClientSummaryDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useClientController_GetClientSummaries.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useClientController_GetClientWithLocations = (
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<ClientWithLocationsInfo>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_GetClientWithLocations.info(
    clientId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_GetClientWithLocations.info = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [ClientController_GetClientWithLocations.key, clientId] as QueryKey,
    fun: () =>
      ClientController_GetClientWithLocations(
        clientId,

        configOverride,
      ),
  };
};
useClientController_GetClientWithLocations.prefetch = (
  client: QueryClient,
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<ClientWithLocationsInfo>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_GetClientWithLocations.info(
    clientId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useClientController_GetClients = (
  options?: SwaggerTypescriptUseQueryOptions<ClientInfo[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_GetClients.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_GetClients.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [ClientController_GetClients.key] as QueryKey,
    fun: () => ClientController_GetClients(configOverride),
  };
};
useClientController_GetClients.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<ClientInfo[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_GetClients.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useClientController_Overview = (
  clientId: number,
  queryParams?: ClientController_OverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<ClientOverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_Overview.info(
    clientId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_Overview.info = (
  clientId: number,
  queryParams?: ClientController_OverviewQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [ClientController_Overview.key, clientId, queryParams] as QueryKey,
    fun: () =>
      ClientController_Overview(
        clientId,

        queryParams,

        configOverride,
      ),
  };
};
useClientController_Overview.prefetch = (
  client: QueryClient,
  clientId: number,
  queryParams?: ClientController_OverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<ClientOverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_Overview.info(
    clientId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useClientController_RangeLiceReport = (
  clientId: number,
  queryParams: ClientController_RangeLiceReportQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<RangeReportResult>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_RangeLiceReport.info(
    clientId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_RangeLiceReport.info = (
  clientId: number,
  queryParams: ClientController_RangeLiceReportQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      ClientController_RangeLiceReport.key,
      clientId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      ClientController_RangeLiceReport(
        clientId,

        queryParams,

        configOverride,
      ),
  };
};
useClientController_RangeLiceReport.prefetch = (
  client: QueryClient,
  clientId: number,
  queryParams: ClientController_RangeLiceReportQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<RangeReportResult>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_RangeLiceReport.info(
    clientId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useClientController_RangeLiceReports = (
  clientId: number,
  queryParams: ClientController_RangeLiceReportsQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<RangeClientReportResult>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_RangeLiceReports.info(
    clientId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_RangeLiceReports.info = (
  clientId: number,
  queryParams: ClientController_RangeLiceReportsQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      ClientController_RangeLiceReports.key,
      clientId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      ClientController_RangeLiceReports(
        clientId,

        queryParams,

        configOverride,
      ),
  };
};
useClientController_RangeLiceReports.prefetch = (
  client: QueryClient,
  clientId: number,
  queryParams: ClientController_RangeLiceReportsQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<RangeClientReportResult>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_RangeLiceReports.info(
    clientId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useClientController_createApiUser = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { clientId: number; requestBody: CreateApiUserInput },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        requestBody,

        configOverride,
      } = _o || {};

      return ClientController_createApiUser(
        clientId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useClientController_getApiUsers = (
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<GetApiUsersResponse[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_getApiUsers.info(
    clientId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_getApiUsers.info = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [ClientController_getApiUsers.key, clientId] as QueryKey,
    fun: () =>
      ClientController_getApiUsers(
        clientId,

        configOverride,
      ),
  };
};
useClientController_getApiUsers.prefetch = (
  client: QueryClient,
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<GetApiUsersResponse[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_getApiUsers.info(
    clientId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useClientController_getClientVideoStreamSettings = (
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<BioscopeStreamSettingsRowDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_getClientVideoStreamSettings.info(
    clientId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useClientController_getClientVideoStreamSettings.info = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      ClientController_getClientVideoStreamSettings.key,
      clientId,
    ] as QueryKey,
    fun: () =>
      ClientController_getClientVideoStreamSettings(
        clientId,

        configOverride,
      ),
  };
};
useClientController_getClientVideoStreamSettings.prefetch = (
  client: QueryClient,
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<BioscopeStreamSettingsRowDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useClientController_getClientVideoStreamSettings.info(
    clientId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useClientController_updateBioscopeVideoStreamSettings = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    VideoStreamSettingsDto,
    {
      clientId: number;
      bioscopeId: number;
      requestBody: UpdateVideoStreamSettingsInput;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        bioscopeId,
        requestBody,

        configOverride,
      } = _o || {};

      return ClientController_updateBioscopeVideoStreamSettings(
        clientId,
        bioscopeId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useClientController_updateClient = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ClientInfo,
    { clientId: number; requestBody: UpdateClientDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        requestBody,

        configOverride,
      } = _o || {};

      return ClientController_updateClient(
        clientId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useClientController_updateLocationVideoStreamSettings = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    VideoStreamSettingsDto[],
    {
      clientId: number;
      locationId: number;
      requestBody: UpdateVideoStreamSettingsInput;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        locationId,
        requestBody,

        configOverride,
      } = _o || {};

      return ClientController_updateLocationVideoStreamSettings(
        clientId,
        locationId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Get compare data for all cages at a location
 */
export const useCompareController_getLocationCompare = (
  clientId: number,
  locationId: number,
  queryParams?: CompareController_getLocationCompareQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<LocationCompareResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCompareController_getLocationCompare.info(
    clientId,
    locationId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useCompareController_getLocationCompare.info = (
  clientId: number,
  locationId: number,
  queryParams?: CompareController_getLocationCompareQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      CompareController_getLocationCompare.key,
      clientId,
      locationId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      CompareController_getLocationCompare(
        clientId,
        locationId,

        queryParams,

        configOverride,
      ),
  };
};
useCompareController_getLocationCompare.prefetch = (
  client: QueryClient,
  clientId: number,
  locationId: number,
  queryParams?: CompareController_getLocationCompareQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<LocationCompareResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useCompareController_getLocationCompare.info(
    clientId,
    locationId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Get all notices and banner messages
 */
export const useContentController_getSanityContent = (
  options?: SwaggerTypescriptUseQueryOptions<SanityContentResponse>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useContentController_getSanityContent.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useContentController_getSanityContent.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [ContentController_getSanityContent.key] as QueryKey,
    fun: () => ContentController_getSanityContent(configOverride),
  };
};
useContentController_getSanityContent.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<SanityContentResponse>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useContentController_getSanityContent.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Mint or rotate a device API key
 */
export const useDeviceKeyController_CreateApiKey = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      /**
       *
       * Registered device_type.name: bioscope, winch, router, server, …
       */
      deviceType: string;
      /**
       *
       * Public device id
       */
      deviceId: number;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        deviceType,
        deviceId,

        configOverride,
      } = _o || {};

      return DeviceKeyController_CreateApiKey(
        deviceType,
        deviceId,

        configOverride,
      );
    },
    ...options,
  });
};

export const useFeedbackController_ImageFeedback = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: ImageFeedbackDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return FeedbackController_ImageFeedback(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Get site feeding dashboard configuration
 */
export const useFeedingDashboardController_getConfig = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<FeedingDashboardConfigDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFeedingDashboardController_getConfig.info(
    locationId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useFeedingDashboardController_getConfig.info = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [FeedingDashboardController_getConfig.key, locationId] as QueryKey,
    fun: () =>
      FeedingDashboardController_getConfig(
        locationId,

        configOverride,
      ),
  };
};
useFeedingDashboardController_getConfig.prefetch = (
  client: QueryClient,

  /**
   *
   * Location (site) ID
   */
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<FeedingDashboardConfigDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFeedingDashboardController_getConfig.info(
    locationId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Feeding performance dashboard overview for a site
 */
export const useFeedingDashboardController_getOverview = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  queryParams?: FeedingDashboardController_getOverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<FeedingDashboardOverviewDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFeedingDashboardController_getOverview.info(
    locationId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useFeedingDashboardController_getOverview.info = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  queryParams?: FeedingDashboardController_getOverviewQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      FeedingDashboardController_getOverview.key,
      locationId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      FeedingDashboardController_getOverview(
        locationId,

        queryParams,

        configOverride,
      ),
  };
};
useFeedingDashboardController_getOverview.prefetch = (
  client: QueryClient,

  /**
   *
   * Location (site) ID
   */
  locationId: number,
  queryParams?: FeedingDashboardController_getOverviewQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<FeedingDashboardOverviewDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFeedingDashboardController_getOverview.info(
    locationId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Override the site configuration for one pen
 */
export const useFeedingDashboardController_updateCageConfig = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    FeedingDashboardConfigDto,
    {
      /**
       *
       * Location (site) ID
       */
      locationId: number;
      /**
       *
       * Pen (cage) ID
       */
      cageId: number;
      requestBody: UpdateFeedingCageConfigDto;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        locationId,
        cageId,
        requestBody,

        configOverride,
      } = _o || {};

      return FeedingDashboardController_updateCageConfig(
        locationId,
        cageId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Update site feeding dashboard configuration
 */
export const useFeedingDashboardController_updateConfig = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    FeedingDashboardConfigDto,
    {
      /**
       *
       * Location (site) ID
       */
      locationId: number;
      requestBody: UpdateFeedingDashboardConfigDto;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        locationId,
        requestBody,

        configOverride,
      } = _o || {};

      return FeedingDashboardController_updateConfig(
        locationId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Close a fish group independently (harvest, decommission, operational close)
 */
export const useFishGroupsController_close = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      clientId: number;
      fishGroupId: number;
      requestBody: CloseFishGroupRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        fishGroupId,
        requestBody,

        configOverride,
      } = _o || {};

      return FishGroupsController_close(
        clientId,
        fishGroupId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Create a new fish group (initial placement, no DAG lineage). Internal tooling; customers use POST :clientId/locations/:locationId/fish-groups. stockingCycleId is required unless the caller is an Optoscale admin.
 */
export const useFishGroupsController_create = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { clientId: number; requestBody: CreateFishGroupRequest },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        requestBody,

        configOverride,
      } = _o || {};

      return FishGroupsController_create(
        clientId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Discard a fish group created by mistake (only valid before any DAG activity — no transfers as source or destination)
 */
export const useFishGroupsController_discard = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      clientId: number;
      fishGroupId: number;
      requestBody: DiscardFishGroupRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        fishGroupId,
        requestBody,

        configOverride,
      } = _o || {};

      return FishGroupsController_discard(
        clientId,
        fishGroupId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Timeline of a single cage: every fish group that has lived in this cage, ordered chronologically from earliest to most recent. Excludes soft-deleted (discard) entries.
 */
export const useFishGroupsController_getCageHistory = (
  clientId: number,
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<CageFishGroupHistoryItemDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getCageHistory.info(
    clientId,
    cageId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useFishGroupsController_getCageHistory.info = (
  clientId: number,
  cageId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      FishGroupsController_getCageHistory.key,
      clientId,
      cageId,
    ] as QueryKey,
    fun: () =>
      FishGroupsController_getCageHistory(
        clientId,
        cageId,

        configOverride,
      ),
  };
};
useFishGroupsController_getCageHistory.prefetch = (
  client: QueryClient,
  clientId: number,
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<CageFishGroupHistoryItemDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getCageHistory.info(
    clientId,
    cageId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Detail of a single fish group with its current location (cage + parent location) resolved
 */
export const useFishGroupsController_getDetail = (
  clientId: number,
  fishGroupId: number,
  options?: SwaggerTypescriptUseQueryOptions<FishGroupDetailDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getDetail.info(
    clientId,
    fishGroupId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useFishGroupsController_getDetail.info = (
  clientId: number,
  fishGroupId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      FishGroupsController_getDetail.key,
      clientId,
      fishGroupId,
    ] as QueryKey,
    fun: () =>
      FishGroupsController_getDetail(
        clientId,
        fishGroupId,

        configOverride,
      ),
  };
};
useFishGroupsController_getDetail.prefetch = (
  client: QueryClient,
  clientId: number,
  fishGroupId: number,
  options?: SwaggerTypescriptUseQueryOptions<FishGroupDetailDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getDetail.info(
    clientId,
    fishGroupId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Event history of a fish group (lifecycle + manual events) ordered most-recent-first
 */
export const useFishGroupsController_getEvents = (
  clientId: number,
  fishGroupId: number,
  queryParams?: FishGroupsController_getEventsQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<FishGroupTransferEventDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getEvents.info(
    clientId,
    fishGroupId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useFishGroupsController_getEvents.info = (
  clientId: number,
  fishGroupId: number,
  queryParams?: FishGroupsController_getEventsQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      FishGroupsController_getEvents.key,
      clientId,
      fishGroupId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      FishGroupsController_getEvents(
        clientId,
        fishGroupId,

        queryParams,

        configOverride,
      ),
  };
};
useFishGroupsController_getEvents.prefetch = (
  client: QueryClient,
  clientId: number,
  fishGroupId: number,
  queryParams?: FishGroupsController_getEventsQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<FishGroupTransferEventDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getEvents.info(
    clientId,
    fishGroupId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Lineage of a fish group: ancestors + descendants via closure table, returned as flat lists and as a graph (nodes + edges)
 */
export const useFishGroupsController_getLineage = (
  clientId: number,
  fishGroupId: number,
  options?: SwaggerTypescriptUseQueryOptions<FishGroupLineageDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getLineage.info(
    clientId,
    fishGroupId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useFishGroupsController_getLineage.info = (
  clientId: number,
  fishGroupId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      FishGroupsController_getLineage.key,
      clientId,
      fishGroupId,
    ] as QueryKey,
    fun: () =>
      FishGroupsController_getLineage(
        clientId,
        fishGroupId,

        configOverride,
      ),
  };
};
useFishGroupsController_getLineage.prefetch = (
  client: QueryClient,
  clientId: number,
  fishGroupId: number,
  options?: SwaggerTypescriptUseQueryOptions<FishGroupLineageDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getLineage.info(
    clientId,
    fishGroupId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Full location history of a fish group, ordered from earliest to most recent. Excludes soft-deleted (discard) entries.
 */
export const useFishGroupsController_getLocations = (
  clientId: number,
  fishGroupId: number,
  options?: SwaggerTypescriptUseQueryOptions<FishGroupLocationHistoryItemDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getLocations.info(
    clientId,
    fishGroupId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useFishGroupsController_getLocations.info = (
  clientId: number,
  fishGroupId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      FishGroupsController_getLocations.key,
      clientId,
      fishGroupId,
    ] as QueryKey,
    fun: () =>
      FishGroupsController_getLocations(
        clientId,
        fishGroupId,

        configOverride,
      ),
  };
};
useFishGroupsController_getLocations.prefetch = (
  client: QueryClient,
  clientId: number,
  fishGroupId: number,
  options?: SwaggerTypescriptUseQueryOptions<FishGroupLocationHistoryItemDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getLocations.info(
    clientId,
    fishGroupId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Tabular overview of a client: every location with its non-historical cages and the active fish group on each cage
 */
export const useFishGroupsController_getOverview = (
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<ClientFishGroupsOverviewDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getOverview.info(
    clientId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useFishGroupsController_getOverview.info = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [FishGroupsController_getOverview.key, clientId] as QueryKey,
    fun: () =>
      FishGroupsController_getOverview(
        clientId,

        configOverride,
      ),
  };
};
useFishGroupsController_getOverview.prefetch = (
  client: QueryClient,
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<ClientFishGroupsOverviewDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getOverview.info(
    clientId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * What reverting an operation would do (groups restored and discarded, manual events left on discarded groups) and what blocks it, without changing anything
 */
export const useFishGroupsController_getRevertPreview = (
  clientId: number,
  operationId: number,
  options?: SwaggerTypescriptUseQueryOptions<RevertPreviewDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getRevertPreview.info(
    clientId,
    operationId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useFishGroupsController_getRevertPreview.info = (
  clientId: number,
  operationId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      FishGroupsController_getRevertPreview.key,
      clientId,
      operationId,
    ] as QueryKey,
    fun: () =>
      FishGroupsController_getRevertPreview(
        clientId,
        operationId,

        configOverride,
      ),
  };
};
useFishGroupsController_getRevertPreview.prefetch = (
  client: QueryClient,
  clientId: number,
  operationId: number,
  options?: SwaggerTypescriptUseQueryOptions<RevertPreviewDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useFishGroupsController_getRevertPreview.info(
    clientId,
    operationId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Execute a composition-changing operation (split, merge, or split-and-merge)
 */
export const useFishGroupsController_operate = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { clientId: number; requestBody: FishGroupOperationRequest },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        requestBody,

        configOverride,
      } = _o || {};

      return FishGroupsController_operate(
        clientId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Record a standalone non-lifecycle event on an active fish group (mortality, partial harvest, measurement, feeding, treatment)
 */
export const useFishGroupsController_recordEvent = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      clientId: number;
      fishGroupId: number;
      requestBody: RecordFishGroupEventRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        fishGroupId,
        requestBody,

        configOverride,
      } = _o || {};

      return FishGroupsController_recordEvent(
        clientId,
        fishGroupId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Relocate a fish group to a different empty cage (identity-preserving)
 */
export const useFishGroupsController_relocate = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      clientId: number;
      fishGroupId: number;
      requestBody: RelocateFishGroupRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        fishGroupId,
        requestBody,

        configOverride,
      } = _o || {};

      return FishGroupsController_relocate(
        clientId,
        fishGroupId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Revert (annul) an operation recorded by mistake: discard the groups it created and restore the groups it closed in the stay it closed. Bioscopes are not moved.
 */
export const useFishGroupsController_revertOperation = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      clientId: number;
      operationId: number;
      requestBody: RevertFishGroupOperationRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        operationId,
        requestBody,

        configOverride,
      } = _o || {};

      return FishGroupsController_revertOperation(
        clientId,
        operationId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Correct fish group metadata (name, notes, initial population size). Allowed on any status, including closed groups — a correction is a record fix, not a lifecycle event. Every change is journalled as a metadata_updated event.
 */
export const useFishGroupsController_updateMetadata = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    FishGroupDto,
    {
      clientId: number;
      fishGroupId: number;
      requestBody: UpdateFishGroupMetadataRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        fishGroupId,
        requestBody,

        configOverride,
      } = _o || {};

      return FishGroupsController_updateMetadata(
        clientId,
        fishGroupId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Get health overview data for a cage
 */
export const useHealthController_getHealthData = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: HealthController_getHealthDataQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<HealthOverviewDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useHealthController_getHealthData.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useHealthController_getHealthData.info = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: HealthController_getHealthDataQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [HealthController_getHealthData.key, cageId, queryParams] as QueryKey,
    fun: () =>
      HealthController_getHealthData(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useHealthController_getHealthData.prefetch = (
  client: QueryClient,

  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: HealthController_getHealthDataQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<HealthOverviewDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useHealthController_getHealthData.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Quality (estimated downgrade) for a cage
 */
export const useHealthController_getQuality = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: HealthController_getQualityQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<HealthQualityResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useHealthController_getQuality.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useHealthController_getQuality.info = (
  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: HealthController_getQualityQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [HealthController_getQuality.key, cageId, queryParams] as QueryKey,
    fun: () =>
      HealthController_getQuality(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useHealthController_getQuality.prefetch = (
  client: QueryClient,

  /**
   *
   * Cage ID
   */
  cageId: number,
  queryParams?: HealthController_getQualityQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<HealthQualityResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useHealthController_getQuality.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Daily lice counts for a cage (three-day rolling average)
 */
export const useLiceController_DailyLice = (
  cageId: number,
  queryParams: LiceController_DailyLiceQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<DailyLiceCountResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLiceController_DailyLice.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLiceController_DailyLice.info = (
  cageId: number,
  queryParams: LiceController_DailyLiceQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LiceController_DailyLice.key, cageId, queryParams] as QueryKey,
    fun: () =>
      LiceController_DailyLice(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useLiceController_DailyLice.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams: LiceController_DailyLiceQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<DailyLiceCountResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLiceController_DailyLice.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Sea temperature series for a cage, plotted alongside lice counts
 */
export const useLiceController_GetTemperature = (
  cageId: number,
  queryParams: LiceController_GetTemperatureQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<TemperatureResult[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLiceController_GetTemperature.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLiceController_GetTemperature.info = (
  cageId: number,
  queryParams: LiceController_GetTemperatureQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LiceController_GetTemperature.key, cageId, queryParams] as QueryKey,
    fun: () =>
      LiceController_GetTemperature(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useLiceController_GetTemperature.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams: LiceController_GetTemperatureQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<TemperatureResult[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLiceController_GetTemperature.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Latest three-day lice averages, with the week-on-week change
 */
export const useLiceController_Last200Lice = (
  cageId: number,
  queryParams?: LiceController_Last200LiceQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<Last3DaysResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLiceController_Last200Lice.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLiceController_Last200Lice.info = (
  cageId: number,
  queryParams?: LiceController_Last200LiceQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LiceController_Last200Lice.key, cageId, queryParams] as QueryKey,
    fun: () =>
      LiceController_Last200Lice(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useLiceController_Last200Lice.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams?: LiceController_Last200LiceQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<Last3DaysResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLiceController_Last200Lice.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Compare the sql and core lice implementations for a cage
 */
export const useLiceController_LiceParity = (
  cageId: number,
  queryParams: LiceController_LiceParityQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<{ [x in string | number]: any }>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLiceController_LiceParity.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLiceController_LiceParity.info = (
  cageId: number,
  queryParams: LiceController_LiceParityQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LiceController_LiceParity.key, cageId, queryParams] as QueryKey,
    fun: () =>
      LiceController_LiceParity(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useLiceController_LiceParity.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams: LiceController_LiceParityQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<{ [x in string | number]: any }>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLiceController_LiceParity.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Weekly lice counts for a cage
 */
export const useLiceController_WeeklyLice = (
  cageId: number,
  queryParams: LiceController_WeeklyLiceQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<WeeklyLiceCountResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLiceController_WeeklyLice.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLiceController_WeeklyLice.info = (
  cageId: number,
  queryParams: LiceController_WeeklyLiceQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LiceController_WeeklyLice.key, cageId, queryParams] as QueryKey,
    fun: () =>
      LiceController_WeeklyLice(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useLiceController_WeeklyLice.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams: LiceController_WeeklyLiceQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<WeeklyLiceCountResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLiceController_WeeklyLice.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useLicenseController_addContractLicense = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ContractLicenseRecord,
    { id: number; requestBody: CreateNewContractLicenseInput },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        id,
        requestBody,

        configOverride,
      } = _o || {};

      return LicenseController_addContractLicense(
        id,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useLicenseController_archiveContract = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ContractRecord,
    { id: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        id,

        configOverride,
      } = _o || {};

      return LicenseController_archiveContract(
        id,

        configOverride,
      );
    },
    ...options,
  });
};

export const useLicenseController_createContract = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ContractRecord,
    { requestBody: CreateNewContractInput },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return LicenseController_createContract(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const useLicenseController_createNewLicenseForClient = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: CreateNewLicenseForClientInput },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return LicenseController_createNewLicenseForClient(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const useLicenseController_deleteClientLicenses = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ClientLicenseResponse,
    { id: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        id,

        configOverride,
      } = _o || {};

      return LicenseController_deleteClientLicenses(
        id,

        configOverride,
      );
    },
    ...options,
  });
};

export const useLicenseController_deleteContractLicense = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ContractLicenseRecord,
    { contractId: number; licenseId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        contractId,
        licenseId,

        configOverride,
      } = _o || {};

      return LicenseController_deleteContractLicense(
        contractId,
        licenseId,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const useLicenseController_getAllClientUser = (
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<ClientLicenseUser[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getAllClientUser.info(
    clientId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLicenseController_getAllClientUser.info = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LicenseController_getAllClientUser.key, clientId] as QueryKey,
    fun: () =>
      LicenseController_getAllClientUser(
        clientId,

        configOverride,
      ),
  };
};
useLicenseController_getAllClientUser.prefetch = (
  client: QueryClient,
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<ClientLicenseUser[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getAllClientUser.info(
    clientId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const useLicenseController_getAllClientWithUser = (
  options?: SwaggerTypescriptUseQueryOptions<ClientWithLocations[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useLicenseController_getAllClientWithUser.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLicenseController_getAllClientWithUser.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LicenseController_getAllClientWithUser.key] as QueryKey,
    fun: () => LicenseController_getAllClientWithUser(configOverride),
  };
};
useLicenseController_getAllClientWithUser.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<ClientWithLocations[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useLicenseController_getAllClientWithUser.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const useLicenseController_getAllUser = (
  options?: SwaggerTypescriptUseQueryOptions<LicenseUser[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getAllUser.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLicenseController_getAllUser.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LicenseController_getAllUser.key] as QueryKey,
    fun: () => LicenseController_getAllUser(configOverride),
  };
};
useLicenseController_getAllUser.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<LicenseUser[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getAllUser.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useLicenseController_getClientContracts = (
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<Contract[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getClientContracts.info(
    clientId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLicenseController_getClientContracts.info = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LicenseController_getClientContracts.key, clientId] as QueryKey,
    fun: () =>
      LicenseController_getClientContracts(
        clientId,

        configOverride,
      ),
  };
};
useLicenseController_getClientContracts.prefetch = (
  client: QueryClient,
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<Contract[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getClientContracts.info(
    clientId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const useLicenseController_getClientLicenses = (
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<LicenseResponse[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getClientLicenses.info(
    clientId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLicenseController_getClientLicenses.info = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LicenseController_getClientLicenses.key, clientId] as QueryKey,
    fun: () =>
      LicenseController_getClientLicenses(
        clientId,

        configOverride,
      ),
  };
};
useLicenseController_getClientLicenses.prefetch = (
  client: QueryClient,
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<LicenseResponse[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getClientLicenses.info(
    clientId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useLicenseController_getLicense = (
  options?: SwaggerTypescriptUseQueryOptions<LicenseInfo[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getLicense.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLicenseController_getLicense.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LicenseController_getLicense.key] as QueryKey,
    fun: () => LicenseController_getLicense(configOverride),
  };
};
useLicenseController_getLicense.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<LicenseInfo[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getLicense.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useLicenseController_getLocationsLicense = (
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<LocationsLicenseOverview[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getLocationsLicense.info(
    clientId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLicenseController_getLocationsLicense.info = (
  clientId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LicenseController_getLocationsLicense.key, clientId] as QueryKey,
    fun: () =>
      LicenseController_getLocationsLicense(
        clientId,

        configOverride,
      ),
  };
};
useLicenseController_getLocationsLicense.prefetch = (
  client: QueryClient,
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<LocationsLicenseOverview[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLicenseController_getLocationsLicense.info(
    clientId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useLicenseController_unarchiveContract = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ContractRecord,
    { id: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        id,

        configOverride,
      } = _o || {};

      return LicenseController_unarchiveContract(
        id,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 * @deprecated This endpoint deprecated and will be remove. Please use an alternative
 */
export const useLicenseController_updateClientLicense = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ClientLicenseResponse,
    { id: number; requestBody: UpdateClientLicenseInput },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        id,
        requestBody,

        configOverride,
      } = _o || {};

      return LicenseController_updateClientLicense(
        id,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useLicenseController_updateContract = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ContractRecord,
    { id: number; requestBody: CreateNewContractInput },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        id,
        requestBody,

        configOverride,
      } = _o || {};

      return LicenseController_updateContract(
        id,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useLicenseController_updateContractLicense = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ContractLicenseRecord,
    {
      contractId: number;
      licenseId: number;
      requestBody: CreateNewContractLicenseInput;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        contractId,
        licenseId,
        requestBody,

        configOverride,
      } = _o || {};

      return LicenseController_updateContractLicense(
        contractId,
        licenseId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useLocationController_CreateLocation = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    LocationResponseDto,
    { requestBody: NewLocation },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return LocationController_CreateLocation(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useLocationController_DeleteLocation = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    LocationResponseDto,
    { locationId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        locationId,

        configOverride,
      } = _o || {};

      return LocationController_DeleteLocation(
        locationId,

        configOverride,
      );
    },
    ...options,
  });
};

export const useLocationController_LocationBioscopeStatus = (
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<LocationBioscopeStatusDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLocationController_LocationBioscopeStatus.info(
    locationId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLocationController_LocationBioscopeStatus.info = (
  locationId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      LocationController_LocationBioscopeStatus.key,
      locationId,
    ] as QueryKey,
    fun: () =>
      LocationController_LocationBioscopeStatus(
        locationId,

        configOverride,
      ),
  };
};
useLocationController_LocationBioscopeStatus.prefetch = (
  client: QueryClient,
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<LocationBioscopeStatusDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLocationController_LocationBioscopeStatus.info(
    locationId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useLocationController_LocationWeightStatus = (
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<LocationWeightStatusDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLocationController_LocationWeightStatus.info(
    locationId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLocationController_LocationWeightStatus.info = (
  locationId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [LocationController_LocationWeightStatus.key, locationId] as QueryKey,
    fun: () =>
      LocationController_LocationWeightStatus(
        locationId,

        configOverride,
      ),
  };
};
useLocationController_LocationWeightStatus.prefetch = (
  client: QueryClient,
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<LocationWeightStatusDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLocationController_LocationWeightStatus.info(
    locationId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Mark pens historical, or current again
 */
export const useLocationController_MarkCagesHistorical = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    CageHistoricalDto[],
    { requestBody: MarkCagesHistoricalRequest },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return LocationController_MarkCagesHistorical(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useLocationController_MarkHistorical = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    CageHistoricalDto,
    {
      cageId: number;
      queryParams: LocationController_MarkHistoricalQueryParams;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        cageId,

        queryParams,
        configOverride,
      } = _o || {};

      return LocationController_MarkHistorical(
        cageId,

        queryParams,
        configOverride,
      );
    },
    ...options,
  });
};

export const useLocationController_UpdateLocation = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    LocationResponseDto,
    { locationId: number; requestBody: UpdateLocation },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        locationId,
        requestBody,

        configOverride,
      } = _o || {};

      return LocationController_UpdateLocation(
        locationId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Average depth for every pen at a location
 */
export const useLocationDepthSeriesController_getLocationDepthSeries = (
  clientId: number,
  locationId: number,
  queryParams: LocationDepthSeriesController_getLocationDepthSeriesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<DepthSeriesResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useLocationDepthSeriesController_getLocationDepthSeries.info(
      clientId,
      locationId,

      queryParams,
      configOverride,
    );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLocationDepthSeriesController_getLocationDepthSeries.info = (
  clientId: number,
  locationId: number,
  queryParams: LocationDepthSeriesController_getLocationDepthSeriesQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      LocationDepthSeriesController_getLocationDepthSeries.key,
      clientId,
      locationId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      LocationDepthSeriesController_getLocationDepthSeries(
        clientId,
        locationId,

        queryParams,

        configOverride,
      ),
  };
};
useLocationDepthSeriesController_getLocationDepthSeries.prefetch = (
  client: QueryClient,
  clientId: number,
  locationId: number,
  queryParams: LocationDepthSeriesController_getLocationDepthSeriesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<DepthSeriesResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useLocationDepthSeriesController_getLocationDepthSeries.info(
      clientId,
      locationId,

      queryParams,
      configOverride,
    );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Create a fish group in an empty pen of this site. stockingCycleId (a planned or active cycle of the site) is required unless the caller is an Optoscale admin; species defaults to salmon; the start may be at most one month in the past.
 */
export const useLocationFishGroupsController_create = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      clientId: number;
      locationId: number;
      requestBody: CreateFishGroupRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        locationId,
        requestBody,

        configOverride,
      } = _o || {};

      return LocationFishGroupsController_create(
        clientId,
        locationId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * The site's pens that hold an open stay, in any cycle or none, a stocking registered for a later date included: the pens a new fish group can't go into.
 */
export const useLocationFishGroupsController_occupiedPens = (
  clientId: number,
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<OccupiedPensDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLocationFishGroupsController_occupiedPens.info(
    clientId,
    locationId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLocationFishGroupsController_occupiedPens.info = (
  clientId: number,
  locationId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      LocationFishGroupsController_occupiedPens.key,
      clientId,
      locationId,
    ] as QueryKey,
    fun: () =>
      LocationFishGroupsController_occupiedPens(
        clientId,
        locationId,

        configOverride,
      ),
  };
};
useLocationFishGroupsController_occupiedPens.prefetch = (
  client: QueryClient,
  clientId: number,
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<OccupiedPensDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLocationFishGroupsController_occupiedPens.info(
    clientId,
    locationId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * The site board: the cycle header and every fish group in scope (active and closed, not discarded) with its pen stays, bioscope coverage, events and lineage edges, in one call. Scope: ?stockingCycleId=<id>|unassigned, else the from/to date window (default: the last 180 days).
 */
export const useLocationFishGroupsController_timeline = (
  clientId: number,
  locationId: number,
  queryParams?: LocationFishGroupsController_timelineQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<FishGroupTimelineDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLocationFishGroupsController_timeline.info(
    clientId,
    locationId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useLocationFishGroupsController_timeline.info = (
  clientId: number,
  locationId: number,
  queryParams?: LocationFishGroupsController_timelineQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      LocationFishGroupsController_timeline.key,
      clientId,
      locationId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      LocationFishGroupsController_timeline(
        clientId,
        locationId,

        queryParams,

        configOverride,
      ),
  };
};
useLocationFishGroupsController_timeline.prefetch = (
  client: QueryClient,
  clientId: number,
  locationId: number,
  queryParams?: LocationFishGroupsController_timelineQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<FishGroupTimelineDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useLocationFishGroupsController_timeline.info(
    clientId,
    locationId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useMoveBioscopeController_DeleteLastMove = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { bioscopeId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        bioscopeId,

        configOverride,
      } = _o || {};

      return MoveBioscopeController_DeleteLastMove(
        bioscopeId,

        configOverride,
      );
    },
    ...options,
  });
};

export const useMoveBioscopeController_MoveBioscope = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { bioscopeId: number; requestBody: MoveBioscopeQueryParams },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        bioscopeId,
        requestBody,

        configOverride,
      } = _o || {};

      return MoveBioscopeController_MoveBioscope(
        bioscopeId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Generate EMQX JWT token
 */
export const useMqttJwtController_generateEmqxToken = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: EmqxJwtPayloadDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return MqttJwtController_generateEmqxToken(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Resolve a numeric id as a cage, bioscope, and/or winch
 */
export const useNavigationController_resolveById = (
  id: number,
  options?: SwaggerTypescriptUseQueryOptions<NavigationResolveResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useNavigationController_resolveById.info(
    id,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useNavigationController_resolveById.info = (
  id: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [NavigationController_resolveById.key, id] as QueryKey,
    fun: () =>
      NavigationController_resolveById(
        id,

        configOverride,
      ),
  };
};
useNavigationController_resolveById.prefetch = (
  client: QueryClient,
  id: number,
  options?: SwaggerTypescriptUseQueryOptions<NavigationResolveResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useNavigationController_resolveById.info(
    id,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Search cages by location and pen name
 */
export const useNavigationController_searchByName = (
  queryParams: NavigationController_searchByNameQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<NavigationResolveResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useNavigationController_searchByName.info(
    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useNavigationController_searchByName.info = (
  queryParams: NavigationController_searchByNameQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [NavigationController_searchByName.key, queryParams] as QueryKey,
    fun: () =>
      NavigationController_searchByName(
        queryParams,

        configOverride,
      ),
  };
};
useNavigationController_searchByName.prefetch = (
  client: QueryClient,
  queryParams: NavigationController_searchByNameQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<NavigationResolveResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useNavigationController_searchByName.info(
    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const usePenOverviewController_getPenOverview = (
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<PenOverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = usePenOverviewController_getPenOverview.info(
    locationId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
usePenOverviewController_getPenOverview.info = (
  locationId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [PenOverviewController_getPenOverview.key, locationId] as QueryKey,
    fun: () =>
      PenOverviewController_getPenOverview(
        locationId,

        configOverride,
      ),
  };
};
usePenOverviewController_getPenOverview.prefetch = (
  client: QueryClient,
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<PenOverviewResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = usePenOverviewController_getPenOverview.info(
    locationId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Provider accounts: rows that belong to no pen
 */
export const useProviderAccountsController_getAccounts = (
  options?: SwaggerTypescriptUseQueryOptions<ProviderAccountDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useProviderAccountsController_getAccounts.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useProviderAccountsController_getAccounts.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [ProviderAccountsController_getAccounts.key] as QueryKey,
    fun: () => ProviderAccountsController_getAccounts(configOverride),
  };
};
useProviderAccountsController_getAccounts.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<ProviderAccountDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useProviderAccountsController_getAccounts.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * A client's provider rows, pen by pen
 */
export const useProviderAccountsController_getClientIntegrations = (
  /**
   *
   * Client ID
   */
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<ClientIntegrationRowDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useProviderAccountsController_getClientIntegrations.info(
    clientId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useProviderAccountsController_getClientIntegrations.info = (
  /**
   *
   * Client ID
   */
  clientId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      ProviderAccountsController_getClientIntegrations.key,
      clientId,
    ] as QueryKey,
    fun: () =>
      ProviderAccountsController_getClientIntegrations(
        clientId,

        configOverride,
      ),
  };
};
useProviderAccountsController_getClientIntegrations.prefetch = (
  client: QueryClient,

  /**
   *
   * Client ID
   */
  clientId: number,
  options?: SwaggerTypescriptUseQueryOptions<ClientIntegrationRowDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useProviderAccountsController_getClientIntegrations.info(
    clientId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Create or update one provider's account row
 */
export const useProviderAccountsController_saveAccount = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ProviderAccountDto[],
    {
      /**
       *
       * An account provider
       */
      providerName: string;
      requestBody: SaveProviderAccountRequestDto;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        providerName,
        requestBody,

        configOverride,
      } = _o || {};

      return ProviderAccountsController_saveAccount(
        providerName,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Re-fetch a pen's daily feeding data for a window
 */
export const useProviderConfigActionsController_fetchHistory = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    FetchHistoryResultDto,
    {
      /**
       *
       * Location (site) ID
       */
      locationId: number;
      /**
       *
       * Cage (pen) ID
       */
      cageId: number;
      requestBody: FetchHistoryRequestDto;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        locationId,
        cageId,
        requestBody,

        configOverride,
      } = _o || {};

      return ProviderConfigActionsController_fetchHistory(
        locationId,
        cageId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * List the site's Clarify items for the pen mapping picker
 */
export const useProviderConfigActionsController_listClarifyCatalog = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    ClarifyCatalogDto,
    {
      /**
       *
       * Location (site) ID
       */
      locationId: number;
      requestBody: ClarifyCatalogRequestDto;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        locationId,
        requestBody,

        configOverride,
      } = _o || {};

      return ProviderConfigActionsController_listClarifyCatalog(
        locationId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Test one provider's unsaved config at a site
 */
export const useProviderConfigActionsController_testProviderConfig = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    TestProviderConfigResultDto,
    {
      /**
       *
       * Location (site) ID
       */
      locationId: number;
      providerName: string;
      requestBody: TestProviderConfigRequestDto;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        locationId,
        providerName,
        requestBody,

        configOverride,
      } = _o || {};

      return ProviderConfigActionsController_testProviderConfig(
        locationId,
        providerName,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * A site's provider config, grouped by provider
 */
export const useProviderConfigController_getLocationConfig = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<LocationProviderConfigDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useProviderConfigController_getLocationConfig.info(
    locationId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useProviderConfigController_getLocationConfig.info = (
  /**
   *
   * Location (site) ID
   */
  locationId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      ProviderConfigController_getLocationConfig.key,
      locationId,
    ] as QueryKey,
    fun: () =>
      ProviderConfigController_getLocationConfig(
        locationId,

        configOverride,
      ),
  };
};
useProviderConfigController_getLocationConfig.prefetch = (
  client: QueryClient,

  /**
   *
   * Location (site) ID
   */
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<LocationProviderConfigDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useProviderConfigController_getLocationConfig.info(
    locationId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Schemas of the feeding providers the portal can configure
 */
export const useProviderConfigController_getProviderSchemas = (
  options?: SwaggerTypescriptUseQueryOptions<ProviderSchemaDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useProviderConfigController_getProviderSchemas.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useProviderConfigController_getProviderSchemas.info = (
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [ProviderConfigController_getProviderSchemas.key] as QueryKey,
    fun: () => ProviderConfigController_getProviderSchemas(configOverride),
  };
};
useProviderConfigController_getProviderSchemas.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<ProviderSchemaDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } =
    useProviderConfigController_getProviderSchemas.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Save one provider's config at a site
 */
export const useProviderConfigController_saveProviderConfig = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    LocationProviderConfigDto,
    {
      /**
       *
       * Location (site) ID
       */
      locationId: number;
      providerName: string;
      requestBody: SaveProviderConfigRequestDto;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        locationId,
        providerName,
        requestBody,

        configOverride,
      } = _o || {};

      return ProviderConfigController_saveProviderConfig(
        locationId,
        providerName,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useReportsController_CreateReport = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { cageId: number; requestBody: NewReport },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        cageId,
        requestBody,

        configOverride,
      } = _o || {};

      return ReportsController_CreateReport(
        cageId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useReportsController_DeleteReport = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { cageId: number; reportId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        cageId,
        reportId,

        configOverride,
      } = _o || {};

      return ReportsController_DeleteReport(
        cageId,
        reportId,

        configOverride,
      );
    },
    ...options,
  });
};

export const useReportsController_Report = (
  cageId: number,
  reportId: number,
  options?: SwaggerTypescriptUseQueryOptions<ReportDetail>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useReportsController_Report.info(
    cageId,
    reportId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useReportsController_Report.info = (
  cageId: number,
  reportId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [ReportsController_Report.key, cageId, reportId] as QueryKey,
    fun: () =>
      ReportsController_Report(
        cageId,
        reportId,

        configOverride,
      ),
  };
};
useReportsController_Report.prefetch = (
  client: QueryClient,
  cageId: number,
  reportId: number,
  options?: SwaggerTypescriptUseQueryOptions<ReportDetail>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useReportsController_Report.info(
    cageId,
    reportId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useReportsController_ReportList = (
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<ReportList[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useReportsController_ReportList.info(
    cageId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useReportsController_ReportList.info = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [ReportsController_ReportList.key, cageId] as QueryKey,
    fun: () =>
      ReportsController_ReportList(
        cageId,

        configOverride,
      ),
  };
};
useReportsController_ReportList.prefetch = (
  client: QueryClient,
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<ReportList[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useReportsController_ReportList.info(
    cageId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Split one fish group into several pens (reason "grading" for a grading) or merge several into one pen, at this site. Every result must inherit a stocking cycle unless the caller is an Optoscale admin.
 */
export const useSiteFishGroupActionsController_operate = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      clientId: number;
      locationId: number;
      requestBody: FishGroupOperationRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        locationId,
        requestBody,

        configOverride,
      } = _o || {};

      return SiteFishGroupActionsController_operate(
        clientId,
        locationId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Register a delousing of a whole fish group at this site.
 */
export const useSiteFishGroupActionsController_recordDelousing = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      clientId: number;
      locationId: number;
      fishGroupId: number;
      requestBody: SiteDelousingRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        locationId,
        fishGroupId,
        requestBody,

        configOverride,
      } = _o || {};

      return SiteFishGroupActionsController_recordDelousing(
        clientId,
        locationId,
        fishGroupId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Move a whole fish group to an empty pen of this site, optionally with its bioscopes and a delousing on the same date.
 */
export const useSiteFishGroupActionsController_relocate = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      clientId: number;
      locationId: number;
      fishGroupId: number;
      requestBody: SiteRelocateFishGroupRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        locationId,
        fishGroupId,
        requestBody,

        configOverride,
      } = _o || {};

      return SiteFishGroupActionsController_relocate(
        clientId,
        locationId,
        fishGroupId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Add fish groups of this site to one of its stockings, each with its whole lineage component. Refused when the component leaves the site or the client, or is partly in another stocking. Every changed group gets a metadata_updated event.
 */
export const useSiteStockingAssignmentController_assign = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    AssignFishGroupsToCycleResponseDto,
    {
      clientId: number;
      locationId: number;
      stockingCycleId: number;
      requestBody: SiteStockingAssignmentRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        locationId,
        stockingCycleId,
        requestBody,

        configOverride,
      } = _o || {};

      return SiteStockingAssignmentController_assign(
        clientId,
        locationId,
        stockingCycleId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * The groups that move with this one when its stocking changes (its lineage component), the stockings they are in, and why a site manager can't change it, if so.
 */
export const useSiteStockingAssignmentController_previewLineage = (
  clientId: number,
  locationId: number,
  fishGroupId: number,
  options?: SwaggerTypescriptUseQueryOptions<StockingLineageDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useSiteStockingAssignmentController_previewLineage.info(
    clientId,
    locationId,
    fishGroupId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useSiteStockingAssignmentController_previewLineage.info = (
  clientId: number,
  locationId: number,
  fishGroupId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      SiteStockingAssignmentController_previewLineage.key,
      clientId,
      locationId,
      fishGroupId,
    ] as QueryKey,
    fun: () =>
      SiteStockingAssignmentController_previewLineage(
        clientId,
        locationId,
        fishGroupId,

        configOverride,
      ),
  };
};
useSiteStockingAssignmentController_previewLineage.prefetch = (
  client: QueryClient,
  clientId: number,
  locationId: number,
  fishGroupId: number,
  options?: SwaggerTypescriptUseQueryOptions<StockingLineageDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useSiteStockingAssignmentController_previewLineage.info(
    clientId,
    locationId,
    fishGroupId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Take fish groups of this site out of a stocking, each with its whole lineage component, back to no stocking. Every changed group gets a metadata_updated event.
 */
export const useSiteStockingAssignmentController_unassign = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    UnassignFishGroupsFromCycleResponseDto,
    {
      clientId: number;
      locationId: number;
      stockingCycleId: number;
      requestBody: SiteStockingAssignmentRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        locationId,
        stockingCycleId,
        requestBody,

        configOverride,
      } = _o || {};

      return SiteStockingAssignmentController_unassign(
        clientId,
        locationId,
        stockingCycleId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useSmoltReportController_createReport = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      cageId: number;
      requestBody: CreateSmoltReportDto;
      queryParams?: SmoltReportController_createReportQueryParams;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const { cageId, requestBody, queryParams, configOverride } = _o || {};

      return SmoltReportController_createReport(
        cageId,
        requestBody,
        queryParams,
        configOverride,
      );
    },
    ...options,
  });
};

export const useSmoltReportController_deleteReport = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { cageId: number; reportId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        cageId,
        reportId,

        configOverride,
      } = _o || {};

      return SmoltReportController_deleteReport(
        cageId,
        reportId,

        configOverride,
      );
    },
    ...options,
  });
};

export const useSmoltReportController_getReportDetail = (
  cageId: number,
  reportId: number,
  options?: SwaggerTypescriptUseQueryOptions<SmoltReportDetailResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useSmoltReportController_getReportDetail.info(
    cageId,
    reportId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useSmoltReportController_getReportDetail.info = (
  cageId: number,
  reportId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      SmoltReportController_getReportDetail.key,
      cageId,
      reportId,
    ] as QueryKey,
    fun: () =>
      SmoltReportController_getReportDetail(
        cageId,
        reportId,

        configOverride,
      ),
  };
};
useSmoltReportController_getReportDetail.prefetch = (
  client: QueryClient,
  cageId: number,
  reportId: number,
  options?: SwaggerTypescriptUseQueryOptions<SmoltReportDetailResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useSmoltReportController_getReportDetail.info(
    cageId,
    reportId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useSmoltReportController_listReports = (
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<SmoltReportListResponseDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useSmoltReportController_listReports.info(
    cageId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useSmoltReportController_listReports.info = (
  cageId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [SmoltReportController_listReports.key, cageId] as QueryKey,
    fun: () =>
      SmoltReportController_listReports(
        cageId,

        configOverride,
      ),
  };
};
useSmoltReportController_listReports.prefetch = (
  client: QueryClient,
  cageId: number,
  options?: SwaggerTypescriptUseQueryOptions<SmoltReportListResponseDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useSmoltReportController_listReports.info(
    cageId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useSmsController_SmsWebhook = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: SmsInput },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return SmsController_SmsWebhook(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Assign fish groups to a stocking cycle. Each group's whole lineage component moves with it, and every changed group gets a metadata_updated event. Use ?dryRun=true to preview the cascade and warnings.
 */
export const useStockingCyclesController_assignFishGroups = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    AssignFishGroupsToCycleResponseDto,
    {
      clientId: number;
      stockingCycleId: number;
      requestBody: AssignFishGroupsToCycleRequest;
      queryParams?: StockingCyclesController_assignFishGroupsQueryParams;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        stockingCycleId,
        requestBody,
        queryParams,
        configOverride,
      } = _o || {};

      return StockingCyclesController_assignFishGroups(
        clientId,
        stockingCycleId,
        requestBody,
        queryParams,
        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Create a stocking cycle at a site. The name defaults to the season convention (e.g. 26A) when omitted.
 */
export const useStockingCyclesController_create = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    {
      clientId: number;
      locationId: number;
      requestBody: CreateStockingCycleRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        locationId,
        requestBody,

        configOverride,
      } = _o || {};

      return StockingCyclesController_create(
        clientId,
        locationId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Stocking cycles of a site, newest first, with derived status, stocking window and fallowing, plus the unassigned group count and a suggested name for a new cycle
 */
export const useStockingCyclesController_list = (
  clientId: number,
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<StockingCycleListDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useStockingCyclesController_list.info(
    clientId,
    locationId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useStockingCyclesController_list.info = (
  clientId: number,
  locationId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [StockingCyclesController_list.key, clientId, locationId] as QueryKey,
    fun: () =>
      StockingCyclesController_list(
        clientId,
        locationId,

        configOverride,
      ),
  };
};
useStockingCyclesController_list.prefetch = (
  client: QueryClient,
  clientId: number,
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<StockingCycleListDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useStockingCyclesController_list.info(
    clientId,
    locationId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Update the name, planned start date or notes of a stocking cycle
 */
export const useStockingCyclesController_update = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    StockingCycleDto,
    {
      clientId: number;
      stockingCycleId: number;
      requestBody: UpdateStockingCycleRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        stockingCycleId,
        requestBody,

        configOverride,
      } = _o || {};

      return StockingCyclesController_update(
        clientId,
        stockingCycleId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Edit a stocking cycle of this site from the board: its name, planned start date or notes. Status and stocked weeks stay derived from the groups.
 */
export const useStockingCyclesController_updateAtSite = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    StockingCycleDto,
    {
      clientId: number;
      locationId: number;
      stockingCycleId: number;
      requestBody: UpdateStockingCycleRequest;
    },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        clientId,
        locationId,
        stockingCycleId,
        requestBody,

        configOverride,
      } = _o || {};

      return StockingCyclesController_updateAtSite(
        clientId,
        locationId,
        stockingCycleId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useTasksController_completeTask = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    TaskResponseDto,
    { taskId: number; requestBody: CompleteTaskDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        taskId,
        requestBody,

        configOverride,
      } = _o || {};

      return TasksController_completeTask(
        taskId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useTasksController_getTasks = (
  locationId: number,
  queryParams?: TasksController_getTasksQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<TaskListResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useTasksController_getTasks.info(
    locationId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useTasksController_getTasks.info = (
  locationId: number,
  queryParams?: TasksController_getTasksQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [TasksController_getTasks.key, locationId, queryParams] as QueryKey,
    fun: () =>
      TasksController_getTasks(
        locationId,

        queryParams,

        configOverride,
      ),
  };
};
useTasksController_getTasks.prefetch = (
  client: QueryClient,
  locationId: number,
  queryParams?: TasksController_getTasksQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<TaskListResponseDto>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useTasksController_getTasks.info(
    locationId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useTasksController_ignoreTask = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    TaskResponseDto,
    { taskId: number; requestBody: IgnoreTaskDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        taskId,
        requestBody,

        configOverride,
      } = _o || {};

      return TasksController_ignoreTask(
        taskId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useTasksController_unignoreTask = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    TaskResponseDto,
    { taskId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        taskId,

        configOverride,
      } = _o || {};

      return TasksController_unignoreTask(
        taskId,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Delete a user
 */
export const useUserController_DeleteUser = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    DeleteUserResponse,
    { userId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        userId,

        configOverride,
      } = _o || {};

      return UserController_DeleteUser(
        userId,

        configOverride,
      );
    },
    ...options,
  });
};

export const useUserController_EndImpersonate = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptionsVoid<any, TExtra>,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const { configOverride } = _o || {};

      return UserController_EndImpersonate(configOverride);
    },
    ...options,
  });
};

export const useUserController_ImpersonateUser = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { userId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        userId,

        configOverride,
      } = _o || {};

      return UserController_ImpersonateUser(
        userId,

        configOverride,
      );
    },
    ...options,
  });
};

export const useUserController_InviteUser = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: InviteForm },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return UserController_InviteUser(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useUserController_Login = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: LoginForm },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return UserController_Login(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useUserController_Logout = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptionsVoid<any, TExtra>,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const { configOverride } = _o || {};

      return UserController_Logout(configOverride);
    },
    ...options,
  });
};

export const useUserController_Me = (
  options?: SwaggerTypescriptUseQueryOptions<Me>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useUserController_Me.info(configOverride);
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useUserController_Me.info = (configOverride?: AxiosRequestConfig) => {
  return {
    key: [UserController_Me.key] as QueryKey,
    fun: () => UserController_Me(configOverride),
  };
};
useUserController_Me.prefetch = (
  client: QueryClient,
  options?: SwaggerTypescriptUseQueryOptions<Me>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useUserController_Me.info(configOverride);

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useUserController_RegisterUser = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: RegisterUserForm },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return UserController_RegisterUser(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useUserController_ResetPassword = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: ResetPassword },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return UserController_ResetPassword(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useUserController_ResetPasswordRequest = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { requestBody: ResetPasswordRequest },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return UserController_ResetPasswordRequest(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useUserController_SetUserClientAccess = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    { [x in string | number]: any },
    { userId: number; requestBody: SetUserClientAccessForm },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        userId,
        requestBody,

        configOverride,
      } = _o || {};

      return UserController_SetUserClientAccess(
        userId,
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

export const useUserController_UpdateProfile = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    UserProfileDto,
    { requestBody: UpdateUserProfileDto },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        requestBody,

        configOverride,
      } = _o || {};

      return UserController_UpdateProfile(
        requestBody,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Forcefully disable stream
 */
export const useVideoStreamController_disableBioscopeStream = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { bioscopeId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        bioscopeId,

        configOverride,
      } = _o || {};

      return VideoStreamController_disableBioscopeStream(
        bioscopeId,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Get daily streaming quota exceeded info
 */
export const useVideoStreamController_getBioscopeQuotaCheck = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { bioscopeId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        bioscopeId,

        configOverride,
      } = _o || {};

      return VideoStreamController_getBioscopeQuotaCheck(
        bioscopeId,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Get streams status for location
 */
export const useVideoStreamController_getLocationStreamsStatus = (
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<LocationStreamStatusDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useVideoStreamController_getLocationStreamsStatus.info(
    locationId,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useVideoStreamController_getLocationStreamsStatus.info = (
  locationId: number,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      VideoStreamController_getLocationStreamsStatus.key,
      locationId,
    ] as QueryKey,
    fun: () =>
      VideoStreamController_getLocationStreamsStatus(
        locationId,

        configOverride,
      ),
  };
};
useVideoStreamController_getLocationStreamsStatus.prefetch = (
  client: QueryClient,
  locationId: number,
  options?: SwaggerTypescriptUseQueryOptions<LocationStreamStatusDto[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useVideoStreamController_getLocationStreamsStatus.info(
    locationId,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Start a new stream or join existing stream
 */
export const useVideoStreamController_startStream = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { bioscopeId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        bioscopeId,

        configOverride,
      } = _o || {};

      return VideoStreamController_startStream(
        bioscopeId,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Stop streaming or leave stream
 */
export const useVideoStreamController_stopStream = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { bioscopeId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        bioscopeId,

        configOverride,
      } = _o || {};

      return VideoStreamController_stopStream(
        bioscopeId,

        configOverride,
      );
    },
    ...options,
  });
};

/**
 *
 * Handle Mux webhook notifications
 */
export const useVideoStreamWebhookNewController_handleMuxWebhook = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    { [x in string | number]: any },
    { headerParams?: { "mux-signature": string } },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const { headerParams, configOverride } = _o || {};

      return VideoStreamWebhookNewController_handleMuxWebhook(
        headerParams,
        configOverride,
      );
    },
    ...options,
  });
};

export const useWelfareController_GetFullSizeImage = (
  cageId: number,
  id: string,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useWelfareController_GetFullSizeImage.info(
    cageId,
    id,

    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useWelfareController_GetFullSizeImage.info = (
  cageId: number,
  id: string,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [WelfareController_GetFullSizeImage.key, cageId, id] as QueryKey,
    fun: () =>
      WelfareController_GetFullSizeImage(
        cageId,
        id,

        configOverride,
      ),
  };
};
useWelfareController_GetFullSizeImage.prefetch = (
  client: QueryClient,
  cageId: number,
  id: string,
  options?: SwaggerTypescriptUseQueryOptions<any>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useWelfareController_GetFullSizeImage.info(
    cageId,
    id,

    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * A pen's welfare or lice images of one type, newest first
 */
export const useWelfareController_allImages = (
  cageId: number,
  queryParams?: WelfareController_allImagesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<FullSizeImage[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useWelfareController_allImages.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useWelfareController_allImages.info = (
  cageId: number,
  queryParams?: WelfareController_allImagesQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [WelfareController_allImages.key, cageId, queryParams] as QueryKey,
    fun: () =>
      WelfareController_allImages(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useWelfareController_allImages.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams?: WelfareController_allImagesQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<FullSizeImage[]>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useWelfareController_allImages.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};

/**
 *
 * Black-and-white welfare for a Bioscope 1.0 cage, or a fish group seen through it
 */
export const useWelfareController_getFullWelfare = (
  cageId: number,
  queryParams: WelfareController_getFullWelfareQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<BwWelfareResponse>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useWelfareController_getFullWelfare.info(
    cageId,

    queryParams,
    configOverride,
  );
  return useQuery({
    queryKey: key,
    queryFn: fun,
    ...options,
  });
};
useWelfareController_getFullWelfare.info = (
  cageId: number,
  queryParams: WelfareController_getFullWelfareQueryParams,
  configOverride?: AxiosRequestConfig,
) => {
  return {
    key: [
      WelfareController_getFullWelfare.key,
      cageId,

      queryParams,
    ] as QueryKey,
    fun: () =>
      WelfareController_getFullWelfare(
        cageId,

        queryParams,

        configOverride,
      ),
  };
};
useWelfareController_getFullWelfare.prefetch = (
  client: QueryClient,
  cageId: number,
  queryParams: WelfareController_getFullWelfareQueryParams,
  options?: SwaggerTypescriptUseQueryOptions<BwWelfareResponse>,
  configOverride?: AxiosRequestConfig,
) => {
  const { key, fun } = useWelfareController_getFullWelfare.info(
    cageId,

    queryParams,
    configOverride,
  );

  return client.getQueryData(key)
    ? Promise.resolve()
    : client.prefetchQuery({
        queryKey: key,
        queryFn: () => fun(),
        ...options,
      });
};
export const useWinchController_CreateApiKey = <TExtra,>(
  options?: SwaggerTypescriptUseMutationOptions<
    any,
    { winchId: number },
    TExtra
  >,
) => {
  return useMutation({
    mutationFn: (_o) => {
      const {
        winchId,

        configOverride,
      } = _o || {};

      return WinchController_CreateApiKey(
        winchId,

        configOverride,
      );
    },
    ...options,
  });
};
